import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import { Home, LayoutGrid, Heart, ShoppingBag } from 'lucide-react';
import { AuthContext } from '../../contexts/AuthContext';
import cartService from '../../services/cartService';
import MobileContainer from './MobileContainer';

const UserRouteWrapper = () => {
  const { userAuth } = useContext(AuthContext);
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    const fetchCartCount = async () => {
      if (!userAuth.isAuthenticated) return;
      try {
        const res = await cartService.getCartItemCount();
        if (res.success) setCartCount(res.count || 0);
      } catch (e) {
        console.error('Cart count error:', e);
      }
    };
    fetchCartCount();
  }, [userAuth.isAuthenticated, location.pathname]);

  const navItems = [
    { icon: Home, label: 'Home', path: '/', match: (p) => p === '/' || p === '/user/dashboard' || p === '/user/home' },
    { icon: LayoutGrid, label: 'Collection', path: '/user/browse', match: (p) => p.startsWith('/user/browse') || p.startsWith('/user/categories') },
    { icon: Heart, label: 'Trends', path: '/user/trending', match: (p) => p.startsWith('/user/trending') || p.startsWith('/user/limited-edition') || p.startsWith('/user/wishlist') },
    { icon: ShoppingBag, label: 'Bag', path: '/user/cart', match: (p) => p.startsWith('/user/cart') || p.startsWith('/user/checkout'), badge: cartCount },
  ];

  return (
    <MobileContainer>
      <div className="min-h-screen bg-white pb-16">
        <Outlet />
      </div>

      {/* Bottom Nav — shown on all user pages */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-white border-t border-gray-100 z-50">
        <div className="flex justify-around items-center h-14">
          {navItems.map((item) => {
            const active = item.match(location.pathname);
            const Icon = item.icon;
            return (
              <Link
                key={item.label}
                to={item.path}
                className={`flex flex-col items-center justify-center gap-0.5 relative ${
                  active ? 'text-black' : 'text-gray-400'
                }`}
              >
                <div className="relative">
                  <Icon
                    className="w-[22px] h-[22px]"
                    strokeWidth={active ? 2.2 : 1.5}
                    fill={active ? 'currentColor' : 'none'}
                  />
                  {item.badge > 0 && (
                    <span className="absolute -top-1.5 -right-2.5 bg-blue-500 text-white text-[9px] font-bold min-w-[16px] h-4 flex items-center justify-center rounded-full px-1">
                      {item.badge > 99 ? '99+' : item.badge}
                    </span>
                  )}
                </div>
                <span className={`text-[10px] ${active ? 'font-semibold' : 'font-medium'}`}>
                  {item.label}
                </span>
                {active && (
                  <div className="absolute -top-0.5 w-6 h-[3px] bg-blue-500 rounded-full" />
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </MobileContainer>
  );
};

export default UserRouteWrapper;
